module.exports = __webpack_public_path__ + "img/鸡桑根.266e71df.jpg";